import(/* webpackMode: "eager", webpackExports: ["BlogPostClient"] */ "/home/runner/work/highrays-yt/highrays-yt/src/app/(public)/blog/[slug]/_components/BlogPostClient.tsx");
